.DropdownMenuContent {
  background-color: var(--rv-surface);
  border: 1px solid var(--rv-border);
  border-radius: var(--rv-radius-lg);
  box-shadow: var(--rv-shadow-lg);
  color: var(--rv-fg-1);
  max-height: var(--dropdown-height-medium);
  min-width: var(--space-8xl);
  overflow: hidden auto;
  padding: var(--rv-space-1);
  z-index: var(--rv-z-popover);
}

.DropdownMenuItem {
  align-items: center;
  border-radius: var(--rv-radius-sm);
  cursor: default;
  display: flex;
  font-family: var(--rv-font-ui);
  font-size: var(--rv-text-sm);
  gap: var(--rv-space-2);
  outline: none;
  padding: var(--rv-space-2) var(--rv-space-3);
  position: relative;
  transition:
    background-color var(--rv-dur-fast) var(--rv-ease-out),
    color var(--rv-dur-fast) var(--rv-ease-out);
  user-select: none;
}

.DropdownMenuItem:hover:not(.disabled),
.DropdownMenuItem:focus {
  background-color: var(--rv-bg-app-subtle);
  color: var(--rv-fg-1);
}

.DropdownMenuItem.destructive {
  color: var(--rv-danger-ink);
}

.DropdownMenuItem.destructive:hover:not(.disabled),
.DropdownMenuItem.destructive:focus {
  background-color: var(--rv-danger-bg);
  color: var(--rv-danger-ink);
}

.DropdownMenuItem.disabled {
  opacity: 50%;
  pointer-events: none;
}

.DropdownMenuItem svg {
  flex-shrink: 0;
  height: var(--rv-icon-sm);
  width: var(--rv-icon-sm);
}

.DropdownMenuSeparator {
  background-color: var(--rv-border);
  height: var(--space-3xs);
  margin: var(--rv-space-1) calc(var(--rv-space-1) * -1);
}

.DropdownMenuLabel {
  color: var(--rv-fg-4);
  font-family: var(--rv-font-sans);
  font-size: var(--rv-text-xxs);
  font-weight: var(--rv-w-semibold);
  letter-spacing: var(--rv-track-widest);
  padding: var(--rv-space-2) var(--rv-space-3) var(--rv-space-1);
  text-transform: uppercase;
}

.DropdownMenuCheckboxItem,
.DropdownMenuRadioItem {
  align-items: center;
  border-radius: var(--rv-radius-sm);
  cursor: default;
  display: flex;
  font-family: var(--rv-font-ui);
  font-size: var(--rv-text-sm);
  gap: var(--rv-space-2);
  outline: none;
  padding: var(--rv-space-2) var(--rv-space-3) var(--rv-space-2) var(--rv-space-8);
  position: relative;
  user-select: none;
}

.DropdownMenuCheckboxItem:hover,
.DropdownMenuCheckboxItem:focus,
.DropdownMenuRadioItem:hover,
.DropdownMenuRadioItem:focus {
  background-color: var(--rv-bg-app-subtle);
  color: var(--rv-fg-1);
}

.IndicatorWrapper {
  align-items: center;
  display: flex;
  height: var(--rv-text-sm);
  justify-content: center;
  left: var(--rv-space-3);
  pointer-events: none;
  position: absolute;
  width: var(--rv-text-sm);
}

.IndicatorWrapper svg {
  color: var(--rv-accent);
  height: var(--rv-icon-sm);
  width: var(--rv-icon-sm);
}
